import {
  reserveFlight
} from "./chunk-HUQY4P34.mjs";

// src/hooks/wbk/flights/reserve.ts
import { useMutation } from "@tanstack/react-query";
var useReserveFlight = () => {
  return useMutation({
    mutationFn: reserveFlight
  });
};

export {
  useReserveFlight
};
//# sourceMappingURL=chunk-76JJPA7Z.mjs.map